import { api } from '../lib/api'

export interface AnalyzeResult {
  reportId: string
  status: string
  optimizationsCount: number
  investigationsCount: number
}

export interface AnalyzeOptions {
  overwrite?: boolean
  weekStart?: string
  weekEnd?: string
  datePreset?: string
}

export const analyzeApi = {
  // Dispara a análise manual (fases 1+2). Pode demorar — chama Windsor + Claude.
  // overwrite=true substitui um relatório já existente do mesmo período.
  run: (clientId: string, opts: AnalyzeOptions = {}) =>
    api.post<AnalyzeResult>(`/analyze/${clientId}`, opts),
}
